<!-- 采购退货记账数据操作 -->
<template>
  <div>
    <subComponents ref="showSelectData"></subComponents>
    <div>
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="tabHeight">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0&&scope.row.isShowForm!=1">
                  <el-form label-width="150px" class="baseForm" id="mainInfo" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                    <el-row v-if="dataActionBox.actionType!=2">
                      <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                        :rules="formOneValue.isRequired == 1 ? [{required:  formOneValue.isChange == 1, trigger: ['blur', 'change']}] : []">
                        <!-- 系统字段 -->
                        <!-- <div v-if="formOneValue.isReserved == 1"> -->
                        <!-- 退货复核ID -->
                        <el-tooltip v-if="formOneValue.entityField == 'rgavId'" class="item"
                          :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
                          :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                          <el-input clearable v-if="formOneValue.entityField == 'rgavId'" @focus="openSearch(formOneValue.extractId, 0, 'rgavId')" v-model="sendDataInfo.rgavId" :maxlength="$store.state.inputLength"
                            :disabled="formOneValue.isChange == 0"></el-input>
                        </el-tooltip>
                        <!-- 记账日期 -->
                        <el-date-picker v-else-if="formOneValue.entityField == 'rgamRapdate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                          :disabled="formOneValue.isChange == 0">
                        </el-date-picker>

                        <!-- 单位业务员 -->
                        <el-input clearable v-else-if="formOneValue.entityField == 'salesId'" v-model="sendDataInfo.salesName" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0"></el-input>

                        <!-- 购进单位 -->
                        <el-input clearable v-else-if="formOneValue.entityField == 'smId'" v-model="sendDataInfo.smName" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0"></el-input>

                        <!-- 采购员	 -->
                        <el-input clearable v-else-if="formOneValue.entityField == 'opmId'" v-model="sendDataInfo.opmName" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0"></el-input>
                        <!-- 业务部门 -->
                        <el-input clearable v-else-if="formOneValue.entityField == 'depId'" v-model="sendDataInfo.depName" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0"></el-input>
                        <!-- 备注 -->
                        <el-input clearable v-else-if="formOneValue.entityField == 'rgamRemark'" type="textarea" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"
                          :readonly="formOneValue.isChange == 0" :disabled="formOneValue.isChange == 0"></el-input>
                        <el-input v-else clearable v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength" :disabled="formOneValue.isChange == 0"></el-input>
                      </el-form-item>
                    </el-row>
                    <el-row v-if="dataActionBox.actionType==2">
                      <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                        :rules="formOneValue.isRequired == 1 ? [{required:  formOneValue.isChange == 1, message:formOneValue.showField + '不能为空', trigger: ['blur', 'change']}] : []">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                        <span v-if="formOneValue.fieldType == 'date'">
                          <span v-if="sendDataInfo[formOneValue.entityField]">
                            {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                          </span>
                        </span>
                        <span v-else-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                        </span>
                        <span v-else-if="formOneValue.entityField == 'salesId'">{{sendDataInfo.salesName}}</span>
                        <span v-else-if="formOneValue.entityField == 'smId'">{{sendDataInfo.smName}}</span>
                        <span v-else-if="formOneValue.entityField == 'opmId'">{{sendDataInfo.opmName}}</span>
                        <span v-else-if="formOneValue.entityField == 'depId'">{{sendDataInfo.depName}}</span>
                        <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                  <!-- 明细信息 -->
                  <div>
                    <el-form :inline="true" size="mini">
                      <el-table :data="sendDataInfo.rgbkDetailVos" size="mini" :row-class-name="tableRowClassName" @row-dblclick="openDateilsBox" border style="width: 100%" :height="mxHeight">
                        <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in mxForm" :key="formOneKey" :min-width="formOneValue.fieldWeight" show-overflow-tooltip
                          v-if="formOneValue.isShow==1">
                          <template slot-scope="scope">
                            <span v-if="formOneValue.fieldType == 'date'">
                              <span v-if="scope.row[formOneValue.entityField]">
                                {{$common.getLocalTime(scope.row[formOneValue.entityField])}}
                              </span>
                            </span>
                            <span v-else-if="formOneValue.isRift == 1">
                              <a @click="toDetail(sendDataInfo.rgbkDetailVos[scope.$index][formOneValue.riftField])">
                                {{sendDataInfo.rgbkDetailVos[scope.$index][formOneValue.entityField]}}</a>
                            </span>
                            <!-- 库房 -->
                            <span v-else-if="formOneValue.entityField == 'stId'">{{sendDataInfo.rgbkDetailVos[scope.$index].stName}}</span>
                            <span v-else-if="formOneValue.entityField == 'refstId'">{{sendDataInfo.rgbkDetailVos[scope.$index].refstName}}</span>
                            <span v-else>{{sendDataInfo.rgbkDetailVos[scope.$index][formOneValue.entityField]}}</span>
                          </template>
                        </el-table-column>

                      </el-table>
                    </el-form>
                  </div>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val)=>{mxHeight=val}"></tree>

        <div class="foot">
          <div>
            <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
            <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType!=2">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
          </div>
          <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
            <el-form-item :label="itemV.chineseField" v-for="(itemV,itemK) in footForm" :key="itemK">
              <el-button type="success">{{sendDataInfo[itemV.entityField]}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
      <psReturnExtractionScheme ref="psReturnExtractionScheme" :extractData="extractData" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
  </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue";
import psReturnExtractionScheme from "../byComponents/psReturnExtractionScheme.vue";
export default {
  name: 'purchaseReturnAccountAction',
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    psReturnExtractionScheme
  },
  data() {
    //这里存放数据
    return {
      selectDataTable: false,
      dataActionBox: {
        showStatus: false,
        openMode: 'ltr' || 'rtl',
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      detaislDataInfo: {},
      selectedDataIndex: '',
      sendDataInfo: {
        "rgavId": '',
        "rgavName": '',
        "pisOrderauxinfVo": {
          "coId": 0,
          "coName": "",
          "credit": "",
          "payMethod": "",
          "psaiCarricus": "",
          "psaiCarrier": "",
          "psaiDeptime": 0,
          "psaiExptime": 0,
          "psaiId": 0,
          "psaiReserves1": "",
          "psaiReserves2": "",
          "psaiReserves3": "",
          "psaiReserves4": "",
          "psaiReserves5": "",
          "psaiReserves6": "",
          "settleMethod": ""
        },
        "rgbkDetailVos": [],
        "psomBusdept": 0,
        "psomBuydate": 0,
        "isWms": 0,
        "opmId": 0,
        "opmName": '',
        'psomId': '',
        "depId": "",
        "depName": "",
        "psaiId": 0,
        "psbkmId": "",
        "rgamId": "",
        "rgamRapdate": 0,
        "rgamRemark": "",
        "rgamReserves1": "",
        "rgamReserves2": "",
        "rgamReserves3": "",
        "rgamReserves4": "",
        "rgamReserves5": "",
        "rgamReserves6": "",
        "rgamReviewer": 0,
        "rgamReviewerName": "",
        "rgampurchaserName": "",
        "rgavId": "",
        "rgbmId": "",
        "salesId": "",
        "salesName": "",
        "smId": 0,
        "smName": "",
        "totalCount": 0,
        "totalMoney": 0,
        "totalNumber": 0
      },
      showTabs: '',
      formDataList: [],
      dictionariesData: {},
      userOneList: [],
      goodsList: [],
      storageRoomList: [],
      salesmanList: [],
      detailsBox: {
        status: false,
        type: 0,
        title: "新增" || "修改",
      },
      editDateilsIndex: "",
      exId: "",
      seId: "",
      ceshi: "",
      dialogTitle: "",
      seWidth: "",
      height: "",
      exTitle: "",
      seTitle: "",
      seWidth: "",
      exWidth: "",
      DialogVisible: false,
      DialogExtract: false,
      newFormDataList: [],
      seType: '',
      smId: '',
      ppId: '',
      extractData: {},
      mxHeight: 0,
      tabForm: [],
      mxForm: [],
      footForm: []
    };
  },
  //监听属性 类似于data概念
  computed: {
  },
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {
    tabHeight(val) {
      this.mxHeight = val
    },
    showPrintPlan() { // 打印方法
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
      } else {
        return
      }
    },
    toDetail(orderId) {
      if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
      else this.$parent.$parent.$parent.toDetail(orderId)
    },
    async getDataByChen(val) {
      console.log(val)
      if (val != "" || val != undefined) {
        for (let key in val) {
          if (key == 'arrlistbychen') {
            this.sendDataInfo.rgbkDetailVos = val.arrlistbychen
          } else {
            this.sendDataInfo[key] = val[key]
          }
        }
        this.sendDataInfo.rgbkDetailVos.forEach(item => {
          item.rgdOldnumber = item.rgreOldnumber
          item.rgdRetnumber = item.rgreRetnumber
        })
        let responseData = await this.$http.getOrderId({ ids: [val.psaiId] })
        this.sendDataInfo.pisOrderauxinfVo = responseData.result
        this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
        this.DialogExtract = false;
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 提取方案Id, 索引(表格中), 标识
    openSearch(eId, index, type) {
      this.DialogExtract = true
      this.exId = eId
      this.seIndex = index
      this.seType = type
      this.ppId = 'rgavId'
      this.extractData = {
        id: this.exId,
        ppId: this.ppId,
        idType: 'ormId'
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    openDateilsBox(row, column, event) {
      if (this.sendDataInfo.smName == '' || this.sendDataInfo.pisOrderAuxinf.coName == '') {
        if (this.sendDataInfo.smName == '') return this.$message({
          message: '请选择购进单位',
          type: 'warning'
        });
        if (this.sendDataInfo.pisOrderAuxinf.coName == '') return this.$message({
          message: '请填写货主',
          type: 'warning'
        });

      } else {
        if (row) {
          this.editDateilsIndex = row.index
          // this.detailsBox.title = "修改明细信息"
          this.detaislDataInfo = JSON.parse(JSON.stringify(row))
        } else {
          this.detaislDataInfo = {
            "bgmId": "",
            "bgmName": '',
            "inRate": 0,
            "money": 0,
            "psodPacknum": 0,
            "price": 0,
            "psodPsdvolume": 0,
            "psodPslowerlimit": 0,
            "psmoney": 0,
            "psodPsnvolume": 0,
            "psprice": 0,
            // 进项税率
            "inRate": 0,
            "psodPsupperlimit": 0,
            "psodReserves1": "",
            "psodReserves2": "",
            "psodReserves3": "",
            "psodReserves4": "",
            "psodReserves5": "",
            "psodReserves6": "",
            "psomId": "",
            "pspdId": "",
            "stId": "",
            "depId": ''
          }
          this.detailsBox.title = "新增明细信息"
          this.sendDataInfo.rgbkDetailVos.push(this.detaislDataInfo)
        }
      }


      // this.detailsBox.status = true
    },
    detailsAction(cate = 0) {
      if (cate == 0) {
        this.editDateilsIndex = ""
        return false
      }
      var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo))
      if (dataInfo.psodPacknum <= 0) {
        this.$message({
          message: '请填写采购数量',
          type: 'error'
        });
        return false
      }
      if (this.editDateilsIndex !== "") {
        this.sendDataInfo.rgbkDetailVos.splice(this.editDateilsIndex, 1)
      }
      this.sendDataInfo.rgbkDetailVos.push(dataInfo)
      this.editDateilsIndex = ""
      this.detailsBox.status = false
    },
    initActionBox(sendDataInfo) {
      this.$confirm('确定取消新增吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dataActionBox.actionType = 0
        this.$emit('drawerCancel')
        this.$refs.sendDataInfo.resetFields();
        this.init()

      }).catch(() => { });
    },

    // 选择采购员
    selectUserOne(data) {
      data.forEach(item => {
        if (item.opmId == this.sendDataInfo.opmId) {
          this.sendDataInfo.psomBusdept = item.depId
        }
      })
    },
    async isShowData(name, value) {
      switch (name) {
        case 'supplier':
          var dataInfo = sessionStorage.getItem('selectSupplierData')
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo)
            this.sendDataInfo.smId = dataInfo.smId
            this.sendDataInfo.smName = dataInfo.smName

          }
          this.sendDataInfo.salesId = ''
          this.getUnitSalesmanList()
          break;
        case 'cargoOwner':
          var dataInfo = sessionStorage.getItem('selectCargoOwnerData')
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo)
            this.sendDataInfo.pisOrderAuxinf.coId = dataInfo.coId
            this.sendDataInfo.pisOrderAuxinf.coName = dataInfo.coName
          }
          break;
      }
    },
    openBox() {
      this.dataActionBox.actionType = this.actionData.cate
      this.formDataList = this.actionData.formData
      var oldData = this.actionData.oldData
      this.showTabs = this.actionData.formData[0].jciName
      this.init()
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = '新增信息'
        this.dataActionBox.openMode = 'ltr'
        this.getUnitSalesmanList()
      } else if (this.dataActionBox.actionType == 1) {
        this.dataActionBox.boxTitle = '编辑信息'
        this.dataActionBox.openMode = 'rtl'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
        }
        this.smId = dataInfo.smId
        this.getUnitSalesmanList()
      } else {
        this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
          if (key == 'detailVoList') this.sendDataInfo.rgbkDetailVos = dataInfo[key]
        }
      }
      this.filterMainField()
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.$refs['tree'].init(this.sendDataInfo.rgbmId)
            this.mxHeight = this.$common.getHeight()
          }
        }, 100)
      })
    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == 'pisOrderauxinfVo') {
          for (let sonOne in this.sendDataInfo[key]) {
            this.sendDataInfo[key][sonOne] = ''
          }
        } else {
          this.sendDataInfo[key] = ''
        }
      }
      this.sendDataInfo.rgbkDetailVos = []
      this.sendDataInfo.psomBuydate = this.$moment().valueOf();

      this.sendDataInfo.rgbkDetailVos = []
      this.sendDataInfo.isWms = 0
      this.sendDataInfo.totalMoney = 0
      this.sendDataInfo.totalNumber = 0
      this.sendDataInfo.totalCount = 0
    },
    sendDataAction(sendDataInfo) {
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.sub()
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    async sub() {
      // if(this.dataActionBox.actionType==0){
      // var responseData =  await this.$http.addPurchaseOrder(this.sendDataInfo)
      // }else{
      //     var responseData =  await this.$http.setPurchaseOrder(this.sendDataInfo)
      // }
      var responseData = await this.$http.addPsReturnAccountList(this.sendDataInfo)
      if (responseData.status == 200) {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.$emit('drawerCancel')
        this.init()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    deleteDetails() {
      if (this.sendDataInfo.rgbkDetailVos.length > 0) {
        if (this.selectedDataIndex == '') {
          return this.$message({
            message: '请先选中明细',
            type: 'warning'
          })
        } else {
          this.sendDataInfo.rgbkDetailVos.splice(this.selectedDataIndex, 1)
          this.selectedDataIndex = ''
        }
      } else {
        return this.$message({
          message: '暂无可删除明细',
          type: 'warning'
        })
      }

    },

    // 获取业务员
    async getUnitSalesmanList() {

      this.salesmanList = []
      let responseData = await this.$http.getUnitSalesmanList({ ids: [this.sendDataInfo.smId] })
      if (responseData.status == 200) {
        this.salesmanList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 获取供货员
    async getSpecialUser() {

      let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 })
      if (responseData.status == 200) {
        this.userOneList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 获取字典数据
    async getPartDictionariesData() {
      let responseData = await this.$http.getPartDictionariesData({ ids: [20, 21] })
      if (responseData.status == 200) {
        this.dictionariesData = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 获取所有可用库房列表
    async getAllStorageRoom() {
      let responseData = await this.$http.getAllStorageRoom()
      if (responseData.status == 200) {
        this.storageRoomList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = []
      this.formDataList.forEach(item => {
        if (item.jciType == 1) {
          mainFormList.push(item)
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
        }
      })
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key))
        this.tabForm[i].jurconfigform = []
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
        }
      })
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      var params = this.actionData
      this.openBox()
    })
    this.getSpecialUser()
    this.getUnitSalesmanList()
    this.getPartDictionariesData()
    this.getAllStorageRoom()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() {
  }, //生命周期 - 创建之前
  beforeMount() {
  }, //生命周期 - 挂载之前
  beforeUpdate() {
  }, //生命周期 - 更新之前
  updated() {
  }, //生命周期 - 更新之后
  beforeDestroy() {
  }, //生命周期 - 销毁之前
  destroyed() {
  }, //生命周期 - 销毁完成
  activated() {
  }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}
.table_content_box {
  /* height: 500px !important; */
  overflow-y: auto;
}
.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}
.foot {
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: absolute;
    bottom: -27px;
    left: 49%;
    transform: translate(-50%, -50%); */
  width: 100%;
  background: #fff;
  padding: 14px 0;
  z-index: 999;
}
.foot .el-form {
  margin-left: 20px;
}
.foot .el-form .el-form-item {
  margin-bottom: 0;
}
.el-drawer {
  outline: none;
}
</style>